import type { RouteRecordName } from 'vue-router'

import router from '@/app/router'

import { pathNames } from '@/shared/utils/constants'

export const isCallSessionRouteName = (name: RouteRecordName | null | undefined): boolean => (
  name === pathNames.CALL_SESSION || name === pathNames.GUEST_CALL_SESSION
)

export const isOnCallSessionRoute = (): boolean => (
  isCallSessionRouteName(router.currentRoute.value.name)
)
